export function youTubeGetID(url: string): string | undefined {
  const parts = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  if (parts.length == 1) {
    return undefined;
  }

  return undefined !== parts[2] ? parts[2].split(/[^0-9a-z_\-]/i)[0] : url;
}
